import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useQueryParam } from "@src/hooks/util";
import { GENERAL_ROUTES } from "@src/routes/routes";

interface LoginBaseRouteProps {}

export const LoginRedirect: React.FC<LoginBaseRouteProps> = () => {
  const navigate = useNavigate();
  const returnUrl = useQueryParam("returnUrl");
  useEffect(() => {
    if (returnUrl) {
      void navigate(returnUrl);
    } else {
      void navigate(GENERAL_ROUTES.Index);
    }
  }, []);

  return null;
};
